import React from "react";
import PropTypes from "prop-types";
import { Navbar, Container } from "react-bootstrap";
import { X } from "lucide-react";
import logo from "../../../assets/images/Logo smart farm1.jpg"
import "./SidebarMainNavbar.css";


class SidebarMainNavbar extends React.Component {
  constructor(props) {
    super(props);

  }



  render() {
    const { hideLogoText, handleToggleSidebar } = this.props;
    return (
      <div className="main-navbar smartfarm-sidebar-brand">
        <div
          className="align-items-stretch bg-white flex-md-nowrap border-bottom p-0"
          type="light"
        >
          <Navbar.Brand
            className="w-100 mr-0 sidebar-brand-link"
            href="#"
          >
            <div className="d-table m-auto pt-3">
              <div className="sidebar-brand-logo-wrap">
                <img
                  id="main-logo"
                  className="d-inline-block align-top mr-1 sidebar-brand-logo"
                  src={logo}
                  alt="Smart Farm"
                />
                <button
                  type="button"
                  className="toggle-sidebar d-sm-inline d-md-none d-lg-none mb-3"
                  onClick={handleToggleSidebar}
                  aria-label="Close navigation"
                >
                  <X className="toggle-sidebar-icon" aria-hidden="true" />
                </button>
              </div>
              {/*!hideLogoText && (
                <span className="d-none d-md-inline ml-1">Smart Farm</span>
              )*/}

            </div>
          </Navbar.Brand>
          {/* eslint-disable-next-line */}

        </div>
      </div>
    );
  }
}

SidebarMainNavbar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool
};

SidebarMainNavbar.defaultProps = {
  hideLogoText: false
};

export default SidebarMainNavbar;
